//External
import React from "react";

/*******************
@Purpose : Used for terms modal
@Parameter : {}
@Author : INIC
******************/
function TermsModal() {
  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      <div className="onboarding-content-box">
        <p className="onboarding-card-text">
          <b>1. Definitions.</b> &quot;Agreement&quot; refers to all terms and
          conditions specified on both sides of this document, along with any
          addenda, supplementary terms, or materials provided at the time of
          rental. &quot;You&quot; or &quot;Your&quot; collectively includes the
          renter identified on this Agreement, any individual or entity signing
          this Agreement, all Authorized Drivers, and any individual or entity
          authorized by you to incur charges under this Agreement. All parties
          defined as &quot;You&quot; or &quot;Your&quot; are jointly and severally
          liable for obligations arising under this Agreement. &quot;We,&quot;
          &quot;Our,&quot; or &quot;Us&quot; refers to the rental company named in
          this Agreement. &quot;Authorized Driver&quot; includes the renter, the
          renter&apos;s spouse, and, in cases where the renter is a business
          entity (rather than an individual), the renter&apos;s employer or
          co-worker conducting business activities with the renter, provided they
          are at least 25 years old, possess a valid driver&apos;s license, and be
          covered by the insurance policy applicable to this rental. Additionally,
          Authorized Drivers include any individuals expressly listed by us on
          this Agreement. If Collision Damage Waiver (CDW) is purchased, coverage
          applies exclusively to the individuals expressly listed as Authorized
          Drivers on this Agreement, without exception. &quot;Vehicle&quot; means
          the motor vehicle specified on this Agreement or any substitute vehicle
          we provide, including all tires, tools, accessories, equipment, keys, and
          accompanying documentation. &quot;CDW&quot; means Collision Damage
          Waiver. &quot;Rental Period&quot; refers to the duration commencing when
          you take possession of the Vehicle and ending upon its return to and
          acceptance by us. &quot;Deductible&quot; denotes the maximum amount you
          are obligated to pay in the event of damage or loss covered by the CDW,
          as stipulated in this Agreement. &quot;Security Deposit&quot; refers to
          the funds collected at the outset of the rental period and retained by us
          throughout the Rental Period to secure your obligations. Upon return of
          the Vehicle, any outstanding charges or additional expenses incurred
          during the rental will be deducted from the Security Deposit, with any
          remaining balance refunded according to the terms outlined herein.
        </p>
        <p className="onboarding-card-text">
          <b>2. Rental, Indemnity, and Warranties.</b> This Agreement is a
          contract for the rental of the Vehicle. You agree to indemnify us,
          defend us, and hold us harmless from and against any and all claims,
          liabilities, damages, costs, and attorney fees we incur resulting from
          or arising out of your use, possession, or operation of the Vehicle,
          including but not limited to negligent acts, misuse, violations of law,
          or breach of this Agreement. We make no warranties—express, implied, or
          apparent—regarding the Vehicle, including no warranty of merchantability
          and no warranty that the Vehicle is fit for any particular purpose.
        </p>
        <p className="onboarding-card-text">
          <b>3. Condition and Return of Vehicle.</b> You must return the Vehicle
          to one of our locations or to the location specified in this Agreement
          by the date and time indicated, in the same condition as received, except
          for ordinary wear. You agree to remain present during the inspection of
          the Vehicle upon return. The Vehicle must be returned with the same fuel
          level as at the time of checkout and in reasonably clean condition.
          Service, repairs, or replacement of parts or accessories during the
          rental period require our prior written authorization. You are
          responsible for regularly checking and maintaining appropriate fluid
          levels during the rental period. If returning the Vehicle outside of our
          regular operating hours, you must document the Vehicle&apos;s condition
          clearly through a 360-degree video or detailed photographs, including
          visible images of the mileage and fuel gauge, provide these records to us
          upon request, and securely place the keys in the location designated by
          us. Failure to comply with any of these requirements may result in
          additional charges as outlined in paragraph 7 (&quot;Charges&quot;) of
          this Agreement.
        </p>
        <p className="onboarding-card-text">
          <b>4. Responsibility for Damage or Loss; Reporting Obligations.</b> You
          are solely responsible for all physical and mechanical damage to the
          Vehicle, loss of use, diminished value, missing equipment, and
          administrative expenses incurred by us related to any damage claim,
          regardless of fault. You are fully responsible for losses resulting
          from theft, vandalism, or unauthorized use of the Vehicle. Allowing
          unauthorized individuals (anyone not defined as an Authorized Driver in
          this Agreement) to operate the Vehicle constitutes a willful breach of
          this Agreement. You must report to us any accidents involving the
          Vehicle, as well as theft or vandalism, within 24 hours of occurrence,
          and immediately notify the police upon discovery. You agree to fully
          cooperate with us and law enforcement authorities in any related
          investigations, providing necessary documentation and statements upon
          request. Failure to promptly report incidents or fully cooperate may
          result in additional liabilities and fees as outlined in this Agreement.
        </p>
        <p className="onboarding-card-text">
          <b>5. Collision Damage Waiver (CDW).</b> If you accept and pay for the
          Collision Damage Waiver (CDW), upon return of the Vehicle, we will waive
          our right to pursue claims against you for physical and mechanical
          damage to, or loss of, the Vehicle that exceed the deductible amount
          specified in this Agreement. The CDW coverage applies exclusively to
          individuals explicitly listed as Authorized Drivers on this Agreement
          and provides no coverage for liability claims involving third parties.
          This waiver does not apply, and you will remain fully responsible, if
          damage or loss to the Vehicle arises from or is connected with: (a)
          intentional, reckless, or wanton misconduct; (b) driving under the
          influence of alcohol or drugs; (c) unauthorized use of the Vehicle or
          use by an unauthorized driver; (d) failure to promptly report an
          accident or theft to us and to the appropriate authorities; (e)
          engaging in criminal activities; (f) using the Vehicle for racing,
          competition, or off-road driving; (g) towing or pushing anything; (h)
          overloading the Vehicle beyond its rated capacity; or (i) any breach of
          the terms and conditions of this Agreement.
        </p>
        <p className="onboarding-card-text">
          <b>6. Insurance Requirements and Liability.</b> You are fully
          responsible for all damage or loss you cause to the Vehicle and/or to
          third parties. You must maintain and provide evidence of primary auto
          liability, collision, comprehensive, and uninsured/underinsured motorist
          coverage sufficient to cover you, us, and the Vehicle throughout the
          entire Rental Period, unless you have purchased Collision Damage Waiver
          (CDW) from us, in which case your responsibility for Vehicle damage or
          loss is limited by the terms of the CDW. However, CDW does not provide
          third-party liability coverage; you remain solely responsible for
          obtaining adequate insurance for third-party claims. In the event of
          any loss, damage, or liability claim, this Agreement will be governed
          and interpreted according to the laws of the jurisdiction where the
          incident occurs. Failure to comply with these insurance requirements
          constitutes a breach of this Agreement and may result in additional
          charges and liabilities.
        </p>
        <p className="onboarding-card-text">
          <b>7. Additional Charges and Expenses.</b> You agree to promptly pay us
          for all extra charges and expenses due under this Agreement and
          permitted by law, including, but not limited to: (a) rental fees based on
          time and mileage or estimated mileage charges if the odometer or its
          seal is tampered with; (b) fees for additional drivers; (c) charges for
          optional products or services selected; (d) fuel charges if returned
          with less fuel than provided at checkout, or recharging fees if returned
          with a lower battery level for electric vehicles; (e) applicable taxes
          and surcharges; (f) costs related to loss of or damage to the Vehicle,
          including minor scratches, dents, scuffed or scratched rims, other
          cosmetic damages, repair costs, or retail cash value of the Vehicle if
          it cannot be repaired or if we elect to sell it without repairs, plus
          administrative fees; (g) all fines, penalties, court costs, towing,
          storage, impound charges, unpaid tolls, parking tickets, associated late
          fees, and similar expenses assessed against us or the Vehicle during your
          rental period, unless due to our actions; (h) expenses for locating and
          recovering the Vehicle if you fail to return it as agreed or if
          repossessed under this Agreement; (i) reasonable attorney fees and
          collection costs incurred to enforce our rights under this Agreement;
          (j) a late payment fee of 2% per month (or maximum permitted by law) on
          overdue amounts; (k) interest at 1% per month (or maximum permitted by
          California law) on unpaid balances; (l) a recovery fee of $100 plus $15
          per mile between rental and Vehicle return or abandonment locations plus
          additional recovery expenses; (m) a reasonable cleaning fee, not
          exceeding $300, if returned substantially less clean than rented
          (excluding separately detailed charges for smoking, pets, or specific
          cleaning noted herein); and (n) fees or penalties from unauthorized
          geographic use, off-road operation, racetrack usage, or any prohibited
          use. You expressly authorize us to deduct any amounts owed under this
          Agreement from your security deposit and/or charge any payment method we
          have on file, with or without notice. This authorization applies to
          immediate charges incurred at the end of your rental period, as well as
          subsequent charges assessed upon discovery or receipt of invoices or
          notices related to your rental.
        </p>
        <p className="onboarding-card-text">
          <b>8. Security Deposit.</b> You expressly authorize us to apply your
          security deposit toward any outstanding amounts or charges incurred under
          this Agreement. Following settlement of all applicable charges, any
          remaining balance from your security deposit will generally be refunded
          within 14 days after the Vehicle is returned, subject to the provisions
          outlined in this Agreement.
        </p>
        <p className="onboarding-card-text">
          <b>9. Personal Property.</b> We are not responsible for any loss or
          damage to your personal property or the personal property of others that
          is received, handled, stored, left, or carried in or on the Vehicle or at
          our premises, including personal vehicles left parked on our property
          during your rental period. We strongly recommend that you do not leave
          valuable items or personal belongings in the Vehicle. By entering into
          this Agreement, you explicitly release and waive all claims against us,
          our agents, and our employees concerning any such losses or damages,
          except in cases involving our intentional misconduct or gross negligence.
        </p>
        <p className="onboarding-card-text">
          <b>10. Modifications and Amendments.</b> No term of this Agreement can be
          waived or modified except through a written amendment approved by us. To
          extend the rental period, you must obtain our prior approval. Extensions
          may be granted without returning the Vehicle, but any such extension must
          be explicitly approved and confirmed by us through email, text message,
          or other electronic communication, clearly specifying the amended due-in
          date, rental rates, charges, and any additional terms included in the
          amendment. All amendments approved by us will modify only the specific
          terms outlined in such amendments, while all other terms of this
          Agreement shall remain fully valid and enforceable. This Agreement,
          along with any approved amendments, constitutes the entire agreement
          between you and us, superseding any prior communications, promises, or
          understandings related to this rental.
        </p>
        <p className="onboarding-card-text">
          <b>11. Breach of Agreement.</b> The actions described in paragraph 5 of
          this Agreement constitute prohibited uses of the Vehicle and breaches of
          this Agreement. Allowing anyone who is not explicitly listed as an
          Authorized Driver to operate the Vehicle constitutes a material breach of
          this Agreement. Additionally, any violation of applicable local, state,
          or federal laws during your rental period shall also constitute a breach.
          You agree to fully cooperate with us and relevant authorities in any
          investigation or proceeding resulting from your breach or violation. You
          expressly waive any claims or legal recourse against us arising from any
          criminal reports, investigations, or prosecutions initiated as a result
          of your breach or violation. Any other actions or omissions violating the
          terms and conditions of this Agreement, even if not specifically listed
          herein, shall also constitute a breach.
        </p>
        <p className="onboarding-card-text">
          <b>12. Vehicle Tracking Devices.</b> All vehicles are equipped with GPS
          tracking devices. You explicitly acknowledge and consent that these
          devices may collect and transmit location data, and may be activated in
          response to specific events or conditions including, but not limited to:
          suspected theft or abandonment; failure to return the Vehicle at the
          agreed-upon time; excessive speed; unauthorized travel outside permitted
          geographic areas; or other indicators of potential misuse. You agree that
          you have been informed of these devices and their possible activation in
          advance, consistent with applicable California law. Tracking
          information will be used solely for purposes permitted by law, including
          but not limited to vehicle recovery, ensuring vehicle safety and
          security, verifying rental agreement compliance, confirming mileage, fuel
          levels, and providing roadside assistance. Tracking data shall not be used
          to impose penalties or surcharges related to driver behavior.
        </p>
        <p className="onboarding-card-text">
          <b>13. Mid-Trip Cancellation.</b> If you request a mid-trip cancellation,
          please note that rental charges are non-refundable except for any
          remaining rental period beyond seven (7) days from the date we receive
          your cancellation notice. Collision Damage Waiver (CDW) fees are fully
          refundable from the effective end date, with coverage days adjusted
          accordingly. Additionally, monthly and weekly discounts applied at the
          start of your rental may be recalculated or revoked based on the revised
          rental duration resulting from any mid-trip cancellations. We
          specifically reserve the right to terminate your rental immediately, with
          or without prior notice, if we reasonably determine that the Vehicle is
          being misused, is at risk, or if the terms of this rental agreement have
          been breached. In such cases, rental charges will be recalculated based
          on the actual date and time the Vehicle is returned to our possession.
        </p>
        <p className="onboarding-card-text">
          <b>14. Breach, Termination, and Repossession.</b> If you breach any terms
          of this Agreement—including but not limited to excessive speeding,
          reckless or unsafe driving, failure to return the Vehicle by the specified
          time, unauthorized geographic use, allowing unauthorized drivers, or any
          other violation—we may, without prior notice or demand, terminate this
          Agreement and immediately repossess the Vehicle. You will be responsible
          for all costs incurred during repossession, including but not limited to
          towing, storage, collection fees, third-party repossession agency fees,
          and attorney fees. You authorize us to deduct these costs from your
          security deposit, charge them directly to your credit card, or otherwise
          recover them from you.
        </p>
        <p className="onboarding-card-text">
          <b>15. Miscellaneous.</b> Our failure to enforce or delay in enforcing
          any provision of this Agreement does not constitute a waiver of our
          rights to subsequently enforce that or any other provision. Acceptance of
          payment, partial performance, or failure to promptly assert any rights or
          remedies under this Agreement shall not be deemed a waiver or
          relinquishment of such rights or remedies. To the fullest extent
          permitted by applicable law, you expressly release and hold us harmless
          from any liability for consequential, special, incidental, or punitive
          damages related to your rental, reservation, or use of the Vehicle.
          Should any provision of this Agreement be found invalid or
          unenforceable by a court of competent jurisdiction, the remainder of this
          Agreement shall remain valid and enforceable to the fullest extent
          permitted by law. This Agreement constitutes the entire agreement
          between you and us, superseding all previous oral or written agreements,
          representations, or understandings. This Agreement shall be governed by
          and interpreted in accordance with the laws of the State of California,
          and any disputes arising from or related to this Agreement shall be
          resolved exclusively in the courts located within the State of California.
        </p>
      </div>
    </>
  );
}

export default TermsModal;
